import { Backend } from '.';

export const getImprint = async () => {
  return Backend.get<string>('/terms/imprint');
};

export const getPrivacy = async () => {
  return Backend.get<string>('/terms/privacy');
};

export const getTermsAndConditions = async () => {
  return Backend.get<string>('/terms/tnc');
};

export default {
  getImprint,
};
